/*
Generated time: January 20, 2026 03:22
This file was created by the app developer. Feel free to contact the original developer with any questions. It was minified (compressed) by AVADA. AVADA do NOT own this script.
*/

function getRandomNum(e, t) {
    return Math.floor(Math.random() * (t - e)) + e
}
let endTimeG;

function cutDownTime() {
    var e = new Date;
    let t = new Date(endTimeG).getTime() - e.getTime();
    t < 0 && (setupNewCountdown(), t = 0);
    var e = Math.floor(t / 36e5 % 24),
        o = Math.floor(t / 6e4 % 60),
        s = Math.floor(t / 1e3 % 60);
    return {
        hour: 10 <= e ? e : "0" + e,
        minute: 10 <= o ? o : "0" + o,
        second: 10 <= s ? s : "0" + s
    }
}

function setupNewCountdown() {
    var e = getRandomNum(1, 9),
        t = new Date;
    endTimeG = t.setHours(t.getHours() + e)
}
let intervalId;

function getCutDownTime() {
    setupNewCountdown(), intervalId && clearInterval(intervalId), intervalId = setInterval(function() {
        var e = cutDownTime();
        $(".sp_top_cut_down .sp_left_view .sp_hour").html(e.hour), $(".sp_top_cut_down .sp_left_view .sp_minute").html(e.minute), $(".sp_top_cut_down .sp_left_view .sp_second").html(e.second)
    }, 1e3)
}

function mainRender() {
    $(function() {
        $("#root").css("zoom", "normal");
        var e, t = document.body.clientWidth / 1080;
        $("#root").css("zoom", t), window.addEventListener("resize", function() {
            e && clearTimeout(e), e = setTimeout(function() {
                $("#root").css("zoom", "normal");
                var e = document.body.clientWidth / 1080;
                $("#root").css("zoom", e)
            }, 100)
        })
    });
    let o = [
        // 买1
        "https://cdn.shopify.com/s/files/1/0883/6500/7147/files/1_74688b19-7807-42a0-ba9e-28204d773f76.png?v=1772620391", 
        // 买2
        "https://cdn.shopify.com/s/files/1/0883/6500/7147/files/2.webp?v=1772620391",
        // 买3送1
        "https://cdn.shopify.com/s/files/1/0883/6500/7147/files/3.webp?v=1772620391",
        // 买2送1
        "https://cdn.shopify.com/s/files/1/0883/6500/7147/files/20250815-img2.png?v=1755256256", 
        // 买3送2
        "https://cdn.shopify.com/s/files/1/0883/6500/7147/files/20250815-img3.png?v=1755256256"
    ];
    t = o, Array.isArray(t[0]) ? t.forEach(e => {
        e.forEach(e => {
            (new Image).src = e
        })
    }) : t.forEach(e => {
        (new Image).src = e
    }), new Swiper(".sp-swiper1", {
        autoplay: !0,
        autoplay: {
            delay: 3500,
            disableOnInteraction: !1
        },
        slideShadows: !0,
        slidesPerView: "auto",
        spaceBetween: 0,
        centeredSlides: !0,
        loop: !0,
        pagination: {
            el: ".sp-pagination",
            clickable: !0
        }
    });
    let e = window.product;

    function s() {
        console.log(window.product);
        let t = $("#sp-color div.active").attr("data-val");
            // let o = $("#sp-size div.active").attr("data-val");
        return e.filter(e => 
            e.option1 == t 
            // && e.option2 == o
        )[0]
    }

    function n() {
        var e = $("#calcNumber").val(),
            t = (s().price * e / 100).toFixed(2),
            e = (s().compare_at_price * e / 100).toFixed(2),
            t = ($("#sp_price1").html(t), $("#sp_price2").html(e), 100 - Math.ceil(s().price / s().compare_at_price * 100));
        $(".product-part .price-group .sp-row span").html(t)
    }
    $(".sp-option").click(function() {
        $(this).siblings().removeClass("active"), $(this).addClass("active"), n();
        var e = $(this).closest(".product-part");
            // var t = (e.find("#sp-color .sp-option.active").index(), 
            // e.find("#sp-size .sp-option.active").index());
        var t=$("#sp-color .sp-option.active").index()
        e.find(".sp-img-p").attr("src", o[t])
    }), $(".sp-reduce, .sp-add").click(function() {
        $(this).closest(".product-part");
        var e = $(this).siblings("input");
        let t = Number(e.val());
        $(this).hasClass("sp-reduce") ? t = Math.max(1, t - 1) : t += 1, e.val(t), n()
    }), $(".cart-btn").click(function() {
        $(this).children("img").addClass("on"), $(".sp-header-top .sp-cart .num").show(), setTimeout(function() {
            $(".cart-btn").children("img").removeClass("on")
        }, 500), $(".sp-header-top .sp-cart").addClass("on"), setTimeout(function() {
            $(".sp-header-top .sp-cart").removeClass("on")
        }, 500)
    }), $(".sp-btn-style").click(function() {
        var e = $("#calcNumber").val();
        window.location.href = "/cart/" + s().id + ":" + e
    }), $(".product-part .cart-btn").click(function() {
        $(".sp-cart .num").addClass("sp-gray");
        var e = {
                id: s().id,
                quantity: $("#calcNumber").val()
            },
            e = ($.ajax({
                type: "POST",
                url: "/cart/add.js",
                data: e,
                success: function() {
                    $.getJSON(window.Shopify.routes.root + "cart.js", function(e) {
                        $("#cardNum").html(e.item_count)
                    })
                },
                dataType: "json"
            }), $(this).closest(".product-part")),
            t = Number(e.find("input[type='number']").val()),
            o = Number($("#cardNum").html()),
            o = ($("#cardNum").html(o + t), e.find(".sp-img-p")),
            t = o[0].cloneNode(!0),
            e = (t.classList.add("sp_clone"), e.append(t), $(".sp_clone").css({
                width: o[0].width,
                height: o[0].height,
                position: "fixed",
                top: o[0].offsetTop,
                left: o.offset().left,
                "z-index": "99"
            }), $(".sp-cart"));
        $(".sp_clone").animate({
            top: e[0].offsetTop+100,
            left: e[0].offsetLeft + e.width() / 3,
            width: 50,
            height: 50,
            opacity: .4
        }, 500, "linear", function() {
            $(this).animate({
                width: 0,
                height: 0,
                opacity: 0
            }, 0, function() {
                $(this).detach()
            })
        })
    }), document.addEventListener("DOMContentLoaded", function() {
        {
            var e = document.querySelectorAll(".lazy-load");
            let o = new IntersectionObserver(function(e, t) {
                e.forEach(function(e) {
                    var t;
                    e.isIntersecting && (t = (e = e.target).getAttribute("data-src"), e.src = t, o.unobserve(e))
                })
            }, {
                rootMargin: "0px 0px 1300px 0px",
                threshold: 0
            });
            e.forEach(function(e) {
                o.observe(e)
            })
        }
        $(".selectl span").click(function() {
            $(this).addClass("on").siblings().removeClass("on")
        }), $(".selectl span").click(function() {
            $(this).addClass("on").siblings().removeClass("on")
        }), document.querySelectorAll('a[href^="#shopping"]').forEach(function(e) {
            e.addEventListener("click", function(e) {
                e.preventDefault();
                e = document.getElementById("shopping").offsetTop;
                window.scroll({
                    top: e * $("div#root").css("zoom") - 240 * $("div#root").css("zoom"),
                    behavior: "smooth"
                })
            })
        })
    });
    var t = navigator.userAgent || navigator.vendor || window.opera,
        a = /android/i.test(t),
        r = /iPad|iPhone|iPod/.test(t) && !window.MSStream,
        t = !a && !r && !/Iron/.test(t),
        a = (a ? console.log("Android") : r ? console.log("iOS") : t ? console.log("PC") : $(".sp_system").css("letter-spacing", "-4px"), document.getElementsByClassName("gradually"));
    for (let i of a) {
        let t = i.querySelectorAll("span"),
            o = i.querySelector(".sp-detail"),
            s = new IntersectionObserver(e => {
                e.forEach(e => {
                    e.isIntersecting && (t.forEach((e, t) => {
                        e.style.animation = "swift-up-fade 0.5s ease forwards", e.style.animationDelay = .1 * t + "s";
                        e = e.querySelector("i");
                        e && (e.style.animation = "swift-up-fade 0.5s ease forwards", e.style.animationDelay = .1 * t + "s")
                    }), e = .1 * t.length + .3, o && (o.style.animation = "swift-up-fade 0.5s ease forwards", o.style.animationDelay = e + "s"), s.unobserve(i))
                })
            }, {
                threshold: .3
            });
        s.observe(i)
    }
    var c = 170 / Math.sin(Math.PI / 12);
    carouselSwiper = new Swiper("#carousel .swiper", {
        watchSlidesProgress: !0,
        slidesPerView: "auto",
        centeredSlides: !1,
        loop: !0,
        loopedSlides: 3,
        grabCursor: !0,
        autoplay: {
            delay: 0,
            stopOnLastSlide: !1,
            disableOnInteraction: !1
        },
        freeMode: !0,
        speed: 5e3,
        on: {
            progress: function(e, t) {
                for (i = 0; i < this.slides.length; i++) {
                    var o = this.slides.eq(i),
                        s = this.slides[i].progress,
                        n = (s + 1) * (85 - 340 * Math.cos((s + 1) * (1 / 6) * Math.PI) * 1.2 / 4) + "px",
                        a = 30 * (s + 1),
                        s = c - Math.cos((s + 1) * (1 / 6) * Math.PI) * c - 150 + "px";
                    o.transform("translateX(" + n + ") translateZ(" + s + ") rotateY(" + a + "deg)")
                }
            },
            setTransition: function(e, t) {
                for (var o = 0; o < this.slides.length; o++) this.slides.eq(o).transition(t)
            }
        }
    })
}
getCutDownTime(), mainRender();